import styled, { css } from 'styled-components';
import get from 'lodash/get';
import { spacing, size, Heading as RawHeading, TitleAndAction } from 'ui';
import {
  DetailListItemLink,
  DetailListItemTitle,
  DetailListItemLabel,
} from 'ui/Details';
import AuthorTime from 'components/AuthorTime';
import { formatRelativeDate } from 'utils';
import { withTranslation } from 'react-i18next';
import { capitalize } from '@tymate/sergic';

export const Heading = styled(RawHeading)`
  margin-bottom: 0;
  font-size: ${size(0)};
`;

export const Wrapper = styled.div`
  ~ * {
    margin-top: ${spacing(2)};
  }
`;

export const TopicTitle = styled(DetailListItemTitle)`
  font-weight: 400;
  font-size: ${size(2)};
  margin-top: ${spacing(0.75)};
  margin-bottom: ${spacing()};
`;

export const TopicCardExcerpt = styled(DetailListItemLabel)`
  max-width: calc(100vw - 370px);
  margin-top: ${spacing(0.5)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TopicCardPostsCount = styled.span`
  color: ${({ theme }) => theme.primary};
  white-space: nowrap;
  font-weight: 600;
`;

export const TopicMetaUpdated = styled.span`
  color: ${({ theme }) => theme.textLight};
  display: block;
  position: relative;
  padding-left: ${spacing(0.75)};
  font-size: ${size(-1)};

  ${props =>
    props.isUnread &&
    css`
      color: ${({ theme }) => theme.text};
      font-weight: 600;

      &:before {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        content: '';
        display: block;
        width: ${spacing(0.5)};
        height: ${spacing(0.5)};
        background-color: ${({ theme }) => theme.primary};
        border-radius: 100%;
      }
    `};
`;

const TopicCard = ({
  id,
  author,
  displayName,
  updatedAt,
  category,
  equipment,
  currentUserId,
  userWitness,
  attachments,
  createdAt,
  postCount,
  read,
  variant,
  t,
}) => (
  <Wrapper>
    <DetailListItemLink
      to={`/mes-echanges/forum/${id}`}
      isBare
      hasNoBorder
      variant="withShadow"
    >
      <TitleAndAction>
        {Boolean(category) ? (
          <Heading>
            {get(category, 'displayIconUrl') && (
              <img src={category.displayIconUrl} alt="" />
            )}
            {get(category, 'displayName')}
          </Heading>
        ) : (
          <span />
        )}

        <TopicMetaUpdated isUnread={!read}>
          {t('updated')} {formatRelativeDate(updatedAt, true, true)}
        </TopicMetaUpdated>
      </TitleAndAction>

      <TopicTitle>{displayName}</TopicTitle>

      {variant !== 'compact' && (
        <TitleAndAction
          hasNoBottomMargin
          isHiddenOnLargeViewports={variant === 'swipeable'}
        >
          <AuthorTime
            author={{
              displayName: capitalize(author.realName || author.displayName),
              avatarURL: get(author, 'avatarUrl'),
            }}
            timestamp={createdAt}
            small
          />
          {Boolean(postCount) && variant !== 'swipeable' && (
            <TopicCardPostsCount>
              {postCount} {t('answer')}
              {postCount > 1 ? 's' : ''}
            </TopicCardPostsCount>
          )}
        </TitleAndAction>
      )}
    </DetailListItemLink>
  </Wrapper>
);

export default withTranslation('topicCard')(TopicCard);
